import ComingSoonPanel from './ComingSoonPanel';
import { Icon } from '../../components/ui/Icon';

export default function IntegrationsPanel() {
  return (
    <ComingSoonPanel
      title="Integrations"
      subtitle="Connect MagicIntake to the tools your team already uses."
      icon={Icon.link}
      features={[
        { title: 'Google Drive sync',  desc: 'Auto-archive approved docs to a Drive folder.' },
        { title: 'Slack notifications', desc: 'Document events posted to your channels.' },
        { title: 'Zapier connector',     desc: 'Wire MagicIntake into your existing automations.' },
        { title: 'API & webhooks',       desc: 'Build custom workflows via the MagicIntake API.' },
      ]}
    />
  );
}
